import React from 'react';
import { Theme, Typography, useMediaQuery,  } from '@mui/material';

const SubscriptionInfo: React.FC = () => {
  const isMobile = useMediaQuery((theme: Theme) => theme.breakpoints.down('md'));
  return (
    <>
      <Typography variant="h1" lineHeight={!isMobile ? '5.125rem' : '2.125rem'}  fontSize={!isMobile ?'3rem' : '2rem'}  align='center' gutterBottom >
        Select Your Subscription Plan
      </Typography>
      <Typography align='center' sx={{ color: '#fff', fontSize: '1.1rem', mt: -1, mb: 4, textWrap: 'balance' }}>
        Upgrade to unlock unlimited stories. Subscriptions are <strong>free for the first 90 days</strong>.
      </Typography>
    </>
  );
};

export default SubscriptionInfo;
